import { useEffect, useState } from "react";
import { PaintBrush, Check, SpinnerGap } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const SWATCHES = ["#0E1729", "#D96C4A", "#2F6B4F", "#8A5A12", "#7A2E3A", "#1F5F8B", "#151312"];

export function DocBranding() {
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/documents/branding").then((r) => setB(r.data)); }, []);
  if (!b) return null;
  const save = async () => {
    setBusy(true);
    try { setB((await api.put("/documents/branding", b)).data); toast.success("Invoice branding saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="mb-6 grid gap-6 rounded-2xl border border-border bg-white p-6 lg:grid-cols-[1fr,1.3fr]" data-testid="doc-branding">
      <div>
        <h3 className="flex items-center gap-2 font-display text-lg"><PaintBrush /> Invoice branding</h3>
        <p className="mt-1 text-sm text-muted-foreground">Your colour is used for the title and lines on every invoice and receipt.</p>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          {SWATCHES.map((c) => (
            <button key={c} type="button" onClick={() => setB({ ...b, color: c })} title={c} data-testid={`brand-swatch-${c.slice(1)}`}
              className="grid h-9 w-9 place-items-center rounded-full text-white ring-offset-2 transition-transform duration-200 hover:scale-110" style={{ background: c, boxShadow: b.color.toLowerCase() === c.toLowerCase() ? `0 0 0 2px white, 0 0 0 4px ${c}` : "none" }}>
              {b.color.toLowerCase() === c.toLowerCase() && <Check size={16} weight="bold" />}
            </button>
          ))}
          <label className="ml-1 inline-flex h-9 cursor-pointer items-center gap-2 rounded-full border border-border px-3 text-sm">
            <input type="color" value={b.color} onChange={(e) => setB({ ...b, color: e.target.value })} className="h-5 w-5 cursor-pointer border-0 bg-transparent p-0" data-testid="brand-color-input" />
            <span className="font-mono text-xs" data-testid="brand-color-value">{b.color.toUpperCase()}</span>
          </label>
        </div>
        <div className="mt-5 h-2 rounded-full" style={{ background: b.color }} />
        <p className="mt-2 font-display text-2xl font-bold" style={{ color: b.color }}>INVOICE</p>
      </div>
      <div>
        <p className="text-sm font-medium">Payment details</p>
        <p className="text-xs text-muted-foreground">Shown as “How to pay” on invoices. Add your MoMo, Airtel or bank details.</p>
        <Textarea rows={5} className="mt-2" maxLength={800} value={b.payment_details} placeholder={"MTN MoMo: 0772 123 456 (Your name)\nBank: Stanbic, Acc 9030 0012 3456"}
          onChange={(e) => setB({ ...b, payment_details: e.target.value })} data-testid="brand-payment-input" />
        <button onClick={save} disabled={busy} data-testid="brand-save-button" className="mt-3 inline-flex h-10 items-center gap-2 rounded-lg bg-[#0E1729] px-4 text-sm font-semibold text-white disabled:opacity-60">
          {busy && <SpinnerGap className="animate-spin" />} Save branding
        </button>
      </div>
    </section>
  );
}
